module.exports = __webpack_public_path__ + "img/invite-sent-icon.0da592eb.svg";